import { PRD3050_R01Dto } from "./Dto_PRD3050_R01";
import { deleteData, getData, postData, putData } from "src/utils/axios/serverHelper";
import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { PRD3050_R01Filter } from "./Store_PRD3050_R01";
import { formatDate } from "src/utils/string/stringUtil";

const baseUrl = `${config.apiUrl}/PRD3050_R01`;

const getParams = (filter: Partial<PRD3050_R01Filter>, listLength?: number) => {
    return {
		compCd: filter.compCd,
		yearMonth: filter.yearMonth,
		workplaceCd: filter.workplaceCd,
		jobTeam: filter.jobTeam,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		closeTag: filter.closeTag,
		workEmp: filter.workEmp,
		workEmpNm: filter.workEmpNm,
        listLength: listLength || 0
    }
}

// 리스트 조회
export const getPRD3050_R01List = async (option: string, params: Partial<PRD3050_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`;
    return await getData<ResponseDto<PRD3050_R01Dto[]>>(url, { params: getParams(params, listLength) });
}

export const getPRD3050_R01AllCount = async (params: Partial<PRD3050_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, { params: getParams(params, 0) });
}

// 엑셀 다운로드
export const exportPRD3050_R01Excel = async (option: string, params: Partial<PRD3050_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/excel/${option}`;
    return await getData<ResponseDto<string>>(url, { params: getParams(params, listLength) });
}
